export default "__VITE_ASSET__6268b74b__"